/**
 * @file IconRequired Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-required',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.6666666666666666}"
  >
    <g transform="translate(-1698.6666666666665,-1573.3333333333333)">
      <g transform="translate(465.3333333333333,320)">
        <g transform="translate(1233.3333333333333,1253.3333333333333)">
          <rect width="48" height="48" x="0" y="0" fill="#366BEE" rx="24" />
          <path
            fill="${data.colorDesc[2]}"
            fill-rule="nonzero"
            d="M36.39052 16.32176C36.91122 15.80106 37.75544 15.80106 38.27614 16.32176 38.73899 16.7846 38.79041 17.50307 38.43042 18.02272L38.27614 18.20738 22.27614 34.20738C21.8133 34.67022 21.09483 34.72165 20.57519 34.36166L20.39052 34.20738 11.12596 24.94281C10.60526 24.42211 10.60526 23.57789 11.12596 23.05719 11.5888 22.59435 12.30727 22.54292 12.82691 22.90291L13.01158 23.05719 21.33333 31.37867 36.39052 16.32176Z"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
`
);
